/**
 * counter on click
 * @module counter
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'counters';
export const CLICK_HANDLER = 'click';

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */

let $counter = 1;
let $max = 5;

const counterAddHandler = ($el) => {
  const $countAddTarget = $('.js-counter-add');
  const $counterAdd = $($el.data('counter-add'));
  const $counterAriaLabel = $('#quantity-update');
  const $counterMaxValue = $counterAdd.data('max-value');
  if ($counterMaxValue) {
    $max = parseInt($counterMaxValue, 10);
  }

  if (parseInt($counterAdd.text(), 10) <= $max) {
    $counter += 1;
    $counterAdd.text(() => $counter);
    $counterAriaLabel.text(`Quantity ${$counter}`);
    if (parseInt($counterAdd.text(), 10) === $max) {
      $counterAdd.text(() => $counter);
      $countAddTarget.attr('disabled', true);
    }
  } else {
    $counterAdd.text(() => $counter);
    $countAddTarget.attr('disabled', false);
  }
};

const counterSubHandler = ($el) => {
  const $countSubTarget = $('.js-counter-sub');
  const $counterSub = $($el.data('counter-sub'));
  const $counterAriaLabel = $('#quantity-update');

  if (parseInt($counterSub.text(), 10) > 1) {
    $counter -= 1;
    $counterSub.text(() => $counter);
    $counterAriaLabel.text(`Quantity ${$counter}`);
    $el.removeAttr('disabled');
  }
  if (parseInt($counterSub.text(), 10) < 2) {
    $counterSub.text(() => $counter);
    $countSubTarget.attr('disabled', true);
  } else {
    $counterSub.text(() => $counter);
    $countSubTarget.attr('disabled', false);
  }
};

const setEventListeners = ($el, options) => {
  $el.on(CLICK_HANDLER, () => {
    counterAddHandler($el, options);
    counterSubHandler($el, options);
    
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function counter(el, options = {}) {
  const $el = $(el);
  setEventListeners($el, options);
  $counter = 1;
}
registerJQueryPlugin(PLUGIN_NAME, counter);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/counter.js